import React, { useRef } from 'react';
import { cn } from '@/lib/utils';

// Glass panel with subtle 3D tilt micro-interaction
export const GlassCard = ({ children, className, tilt = true, gold = false, testid, ...props }) => {
  const ref = useRef();
  const onMove = (e) => {
    if (!tilt || !ref.current) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const r = ref.current.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    ref.current.style.transform = `perspective(1000px) rotateX(${(-py * 3.5).toFixed(2)}deg) rotateY(${(px * 4).toFixed(2)}deg)`;
  };
  const onLeave = () => { if (ref.current) ref.current.style.transform = 'perspective(1000px) rotateX(0) rotateY(0)'; };
  return (
    <div
      ref={ref}
      data-testid={testid}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={cn('pp-glass pp-noise pp-tilt relative overflow-hidden', gold && 'pp-glass--gold', className)}
      {...props}
    >
      {children}
    </div>
  );
};
